import { FC, MouseEventHandler } from 'react';
import styles from './service-card.module.css';
import { Catalog } from '../../../apis/search-catalog';

interface ServiceCardProps {
    catalog: Catalog;
    onClick: MouseEventHandler;
    onSolicitar: MouseEventHandler;
}

export const ServiceCard: FC<ServiceCardProps> = ({
    catalog,
    onClick,
    onSolicitar,
}) => {
    return (
        <div className={styles.card}>
            <div className={styles.category}>{catalog.category}</div>
            <div className={styles.title}>{catalog.title}</div>
            <div className={styles.footer}>
                <button className={styles.moreInfo} onClick={onClick}>
                    Mais Informações
                </button>
                {catalog.isDigital && (
                    <button className={styles.button} onClick={onSolicitar}>
                        Solicitar
                    </button>
                )}
            </div>
        </div>
    );
};